import { useState } from 'react';
import {useLocation, useParams } from "react-router-dom";
import { filterParam } from "modules/main/services/endpoints";
import { ProductCatalog } from "modules/catalog/components/productCatalog";
import { FilterBlock } from "modules/catalog/components/filterBlock";
import { isDesktopSize } from "utils/is-desktop";
import { useMediaQuery } from "@/hooks/use-media-query";
import { CatalogResponse } from 'modules/catalog/types/catalogResponse';
import { endPointCatalog} from "modules/main/services/endpoints";
import { useFetch } from "modules/main/hooks/useFetch";
import {FetchDataOptions} from 'modules/main/services/fetchData';
import { UserData } from 'modules/authentication/types/user-data';
import { Select, SelectContent, SelectItem,SelectTrigger,SelectValue } from '@/components/ui/select';
import { ArrowDownNarrowWide, ArrowDownWideNarrow} from 'lucide-react';
import { Label } from '@/components/ui/label';
import { getVisitorId } from 'utils/analytics';



const Catalog = () => {    
    const isDesktop = useMediaQuery(isDesktopSize);
    const location = useLocation();
    const path_params = useParams();    
    const params = new URLSearchParams(location.search);
    const section  = path_params.section ?? "";    

    const currentPage = params.get("page") ? params.get("page") : "";
    const brand_filters:filterParam = {
            name:"brand",
            value:params.getAll("brand") ? params.getAll("brand") : []
    }
    const tag_filters:filterParam = {
        name:"tag",
        value:params.getAll("tag") ? params.getAll("tag") : []
    }    
    
    const requestOptions:FetchDataOptions = {
        method:"GET",
        headers:{
            "x-visitor-id": getVisitorId()
        },
        body:undefined
    }

    const userData = JSON.parse(localStorage.getItem("userData")??"{}") as UserData;   
    const [sortBy,setSortBy] = useState("several_options");
    const {data,error,loading} = useFetch<CatalogResponse>(endPointCatalog(section,String(currentPage),sortBy,[brand_filters,tag_filters]),requestOptions);
    return(
    <>
    <main className="py-2 2xl:py-4 px-4 2xl:px-16 flex flex-col gap-2 2xl:gap-4">        
        <span className="font-bold text-sm">{section} {">"} {section} </span>                      
        {/* <AspectRatio ratio={ (isDesktop)?30 / 3:20 / 5}>
            <img className="Image" src="https://t3.ftcdn.net/jpg/03/98/03/96/360_F_398039682_a9khCuqZkrjuGT8l7N5A7TUxn6VjjHgA.jpg" alt=""/>
        </AspectRatio> */}
        {
        (!isDesktop)&&(
        <div className="flex flex-row justify-between">
            <div className="flex gap-2 items-center">
                <FilterBlock isSearch={false} isDesktop={isDesktop} section={section} initialFilters={[brand_filters,tag_filters]}
                    data={data?.filters??[]}/>
                
                <span className="font-bold text-xs">Filtrar</span>        
            </div>        
            <div className='flex gap-2 py-2 items-center'>
                <Select value={sortBy} onValueChange={(value)=>{setSortBy(value)}}>
                    <SelectTrigger className='w-16 text-muted-foreground'>
                        <SelectValue>
                            {
                            (sortBy === "lower_price") ? <ArrowDownNarrowWide className="w-4 h-4"/>:
                                <ArrowDownWideNarrow className="w-4 h-4"/>
                            } 
                        </SelectValue>
                    </SelectTrigger>
                    <SelectContent id="sortby">
                        <SelectItem value='lower_price'>
                            <div className='flex gap-2'><ArrowDownNarrowWide className="w-4 h-4"/>Menor Precio</div>
                        </SelectItem>
                        <SelectItem value='higher_price'>
                            <div className='flex gap-2'><ArrowDownWideNarrow className="w-4 h-4"/>Mayor Precio</div>
                        </SelectItem>
                    </SelectContent>
                </Select>
            </div>            
        </div> 
        )
        } 
        <div className="flex flex-row gap-4">
            {
            (isDesktop)&&(
            <div className="px-2 min-w-52" >                
                <FilterBlock isSearch={false} isDesktop={isDesktop} section={section} initialFilters={[brand_filters,tag_filters]}                
                data={data?.filters??[]}/>
            </div>
            )
            }
            <div className='flex flex-1 flex-col w-full gap-2'>
            { (isDesktop)&&               
                (<div className='flex w-full justify-between align-middle px-8'>
                    <h3 className="pt-2 text-sm"><span className="text-muted-foreground font-bold">PRODUCTOS</span></h3>
                    <div className='flex gap-2 py-2 items-center'> 
                        <Label className='text-xs text-muted-foreground' htmlFor="sortby">Orden</Label>
                        <Select value={sortBy} onValueChange={(value)=>{setSortBy(value)}}>
                            <SelectTrigger className='w-[18em] text-muted-foreground'>
                                <SelectValue placeholder="Ordenar Por"/>
                            </SelectTrigger>
                            <SelectContent id="sortby">                         
                                <SelectItem value='lower_price'>
                                    <div className='flex gap-2'><ArrowDownNarrowWide className="w-4 h-4"/>Menor Precio</div>
                                </SelectItem>
                                <SelectItem value='higher_price'>
                                    <div className='flex gap-2'><ArrowDownWideNarrow className="w-4 h-4"/>Mayor Precio</div>
                                </SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                </div>)      
            }
                <ProductCatalog 
                    section={section}
                    brand_filters={brand_filters}
                    tag_filters={tag_filters}
                    currentPage={currentPage}
                    search_params={location.search}
                    isMobile={!isDesktop}
                    data={data ?? {} as CatalogResponse}
                    error={error}
                    loading={loading}
                    />     
            </div>        
        </div>
    </main>
    </>
    );
    
}


export default Catalog;
